import React, { useState, useEffect } from "react";

import './ReturnResponse.css';

import { colorIcon } from "fixedData";

import { RegisterModalData, RegisterModalObserver, SetModalState } from "interface/PopUp";

import { Svg_ChekedReturn, Svg_Erro } from "components/Svg";

export default function PopUP_ReturnResponse(){

    const [ modalData, setModaldata ]     = useState({});
    const [ showPopUp, setShowPopUp ]     = useState(false);

    function ClosePopUp(){
        SetModalState('ReturnResponse', false);
    }

    function TypeData(){
        switch (modalData.page) {
            case 'erro':
                return(
                    <>
                        <Svg_Erro color="#F00000" className="icons_return" />
                        <div className="title_return">
                            { modalData.text == "" ? "Erro ao registrar as informações, tente novamente!" : modalData.text }
                        </div>
                    </>
                )

            default:
                return(
                    <>
                        <Svg_ChekedReturn color={ colorIcon } className="icons_return" />
                        <div className="title_return">
                            Informações registradas com sucesso.
                        </div>
                    </>
                )
        }
    }

    useEffect(()=>{
        RegisterModalData('ReturnResponse', setModaldata);
        RegisterModalObserver('ReturnResponse', setShowPopUp);
    }, []);

    return(
        (showPopUp ?
            <>
                <div className="PopUp PopUpCenter">
                    <div className="all return_response">
                        <div className="div_data">
                            <div className="content">
                                {
                                    TypeData()
                                }
                                <div className="close_return" onClick={ ()=>{ ClosePopUp() } } style={ { background: colorIcon } }>
                                    Fechar
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="close_all" onClick={ ()=>{ ClosePopUp(); } } />
                </div>
            </>
        : <React.Fragment></React.Fragment>)
    )
};
